export const enum SupportTab {
    STOCK_CHECK = 1,
    STOCK_ON_HAND = 2,
    TRANSACTIONS = 3,
    PURCHASE_ORDER = 4,
    VIEW_ITEMS = 5,
    RECIPIES = 6,
    UOM_CONVERSIONS = 7
  }